import React from 'react';
import Icon, { IconProps } from 'components/Icon';
import { getContext } from 'common';
import NokiaLogoSvg from '@nokia-csf-uxr/ccfk-assets/logos/Nokia_logo_blue.svg';
import _merge from 'lodash/merge';
import Styled from './styles';

export interface NokiaLogoProps extends React.ComponentPropsWithRef<'div'> {
  /** To override the content. */
  children?: React.ReactNode;
  /** To override the theme please refer to the `Readme` tab to learn more. */
  theme?: any;
  /** Forward props to the nested `Icon` component. */
  iconProps?: Partial<IconProps>;
}

/** Nokia logo component. */
const NokiaLogo = React.forwardRef<HTMLElement, NokiaLogoProps>((props: NokiaLogoProps, ref) =>
  getContext(({ RTL, theme }) => {
    const { children, theme: themeProp, iconProps, ...otherProps } = props;
    const resolvedTheme = _merge({}, theme.LOGO, themeProp);
    return (
      <Styled.NokiaLogo ref={ref} $rtl={RTL} theme={resolvedTheme} {...otherProps}>
        <Icon src={NokiaLogoSvg} color={resolvedTheme.color} size={{ width: '100%', height: '100%' }} RTL={false} {...iconProps} />
      </Styled.NokiaLogo>
    );
  }));

NokiaLogo.displayName = 'NokiaLogo';
NokiaLogo.defaultProps = {
  children: undefined,
  theme: {},
  iconProps: undefined
};

/* Exports */
export { NokiaLogo as default };
